import { render, staticRenderFns } from "./ContactSms.vue?vue&type=template&id=5631094e&"
import script from "./ContactSms.vue?vue&type=script&lang=js&"
export * from "./ContactSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports